import React, { useState, useEffect } from 'react';
import './App.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Tubers from './pages/Tubers';
import Contact from './pages/Contact';
import Quiz from './pages/Quiz';
import Roadtrip from './pages/Roadtrip';
import Legal from './pages/Legal';
import Farmhouse from './pages/Farmhouse';
import Explore from './pages/Explore';
import Blog from './pages/Blog';

function App() {
  const [page, setPage] = useState('home');
  const [params, setParams] = useState({});
  const [announce, setAnnounce] = useState(true);

  const go = (id, extra = {}) => {
    setParams(extra);
    setPage(id);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const render = () => {
    switch (page) {
      case 'discover': return <About go={go} />;
      case 'tubers': return <Tubers scrollToJoin={params.scrollToJoin} go={go} />;
      case 'contact': return <Contact go={go} />;
      case 'quiz': return <Quiz go={go} />;
      case 'roadtrip': return <Roadtrip go={go} />;
      case 'farmhouse': return <Farmhouse go={go} />;
      case 'explore': return <Explore go={go} />;
      case 'terms': return <Legal type="terms" />;
      case 'privacy': return <Legal type="privacy" />;
      case 'blog': return <Blog slug={params.slug} go={go} />;
      default: return <Home go={go} scrollToFlowers={params.scrollToFlowers} />;
    }
  };

  return (
    <div className="App">
      {announce && (
        <div className="announce" id="ann">
          <a onClick={() => go('tubers', { scrollToJoin: true })} style={{ cursor: 'pointer' }}><strong>Get first dibs on Dahlia Tubers</strong> — Join Us →</a>
          <button className="announce-x" onClick={() => setAnnounce(false)}>×</button>
        </div>
      )}

      <Nav page={page} go={go} />

      {render()}

      <Footer go={go} />
    </div>
  );
}

export default App;
